/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseNavigationColumnFragment, NavigationColumnFragment, FullNavigationColumnFragment} from '@amblique/contentful/app/contentful/fragments/navigation-column';

/**
 * Get a single NavigationColumn by ID (base - scalars only)
 */
export const getBaseNavigationColumnById = gql`
  ${BaseNavigationColumnFragment}

  query GetBaseNavigationColumnById($id: String!, $locale: String!, $preview: Boolean) {
    navigationColumn(id: $id, locale: $locale, preview: $preview) {
      ...BaseNavigationColumnFragment
    }
  }
`;

/**
 * Get a single NavigationColumn by ID (standard - 1 level deep)
 */
export const getNavigationColumnById = gql`
  ${NavigationColumnFragment}

  query GetNavigationColumnById($id: String!, $locale: String!, $preview: Boolean) {
    navigationColumn(id: $id, locale: $locale, preview: $preview) {
      ...NavigationColumnFragment
    }
  }
`;

/**
 * Get a single NavigationColumn by ID (full - 2 levels deep)
 */
export const getFullNavigationColumnById = gql`
  ${FullNavigationColumnFragment}

  query GetFullNavigationColumnById($id: String!, $locale: String!, $preview: Boolean) {
    navigationColumn(id: $id, locale: $locale, preview: $preview) {
      ...FullNavigationColumnFragment
    }
  }
`;

/**
 * Get all NavigationColumn entries with pagination (base - scalars only)
 */
export const getBaseNavigationColumns = gql`
  ${BaseNavigationColumnFragment}

  query GetBaseNavigationColumns(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [NavigationColumnOrder]
    $where: NavigationColumnFilter
    $preview: Boolean
  ) {
    navigationColumnCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseNavigationColumnFragment
      }
    }
  }
`;

/**
 * Get all NavigationColumn entries with pagination (standard - 1 level deep)
 */
export const getNavigationColumns = gql`
  ${NavigationColumnFragment}

  query GetNavigationColumns(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [NavigationColumnOrder]
    $where: NavigationColumnFilter
    $preview: Boolean
  ) {
    navigationColumnCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...NavigationColumnFragment
      }
    }
  }
`;

/**
 * Get all NavigationColumn entries with pagination (full - 2 levels deep)
 */
export const getFullNavigationColumns = gql`
  ${FullNavigationColumnFragment}

  query GetFullNavigationColumns(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [NavigationColumnOrder]
    $where: NavigationColumnFilter
    $preview: Boolean
  ) {
    navigationColumnCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullNavigationColumnFragment
      }
    }
  }
`;
